'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _flexboxgrid = require('flexboxgrid');

var _flexboxgrid2 = _interopRequireDefault(_flexboxgrid);

var _Row = require('./Row.scss');

var _Row2 = _interopRequireDefault(_Row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Row = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Row, _Component);

  function Row() {
    (0, _classCallCheck3.default)(this, Row);
    return (0, _possibleConstructorReturn3.default)(this, (Row.__proto__ || (0, _getPrototypeOf2.default)(Row)).apply(this, arguments));
  }

  (0, _createClass3.default)(Row, [{
    key: 'render',
    value: function render() {
      var _cx;

      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          className = _props.className,
          reverse = _props.reverse,
          start = _props.start,
          center = _props.center,
          end = _props.end,
          top = _props.top,
          middle = _props.middle,
          bottom = _props.bottom,
          around = _props.around,
          between = _props.between,
          first = _props.first,
          last = _props.last,
          rest = (0, _objectWithoutProperties3.default)(_props, ['tag', 'children', 'className', 'reverse', 'start', 'center', 'end', 'top', 'middle', 'bottom', 'around', 'between', 'first', 'last']);

      var Tag = tag;

      var _className = (0, _classnames2.default)(className, _Row2.default.row, _flexboxgrid2.default.row, (_cx = {}, (0, _defineProperty3.default)(_cx, _flexboxgrid2.default.reverse, _flexboxgrid2.default.reverse && reverse), (0, _defineProperty3.default)(_cx, _flexboxgrid2.default['start-' + start], start && _flexboxgrid2.default['start-' + start]), (0, _defineProperty3.default)(_cx, _flexboxgrid2.default['center-' + center], center && _flexboxgrid2.default['center-' + center]), (0, _defineProperty3.default)(_cx, _flexboxgrid2.default['end-' + end], end && _flexboxgrid2.default['end-' + end]), (0, _defineProperty3.default)(_cx, _flexboxgrid2.default['top-' + top], top && _flexboxgrid2.default['top-' + top]), (0, _defineProperty3.default)(_cx, _flexboxgrid2.default['middle-' + middle], middle && _flexboxgrid2.default['middle-' + middle]), (0, _defineProperty3.default)(_cx, _flexboxgrid2.default['bottom-' + bottom], bottom && _flexboxgrid2.default['bottom-' + bottom]), (0, _defineProperty3.default)(_cx, _flexboxgrid2.default['around-' + around], around && _flexboxgrid2.default['around-' + around]), (0, _defineProperty3.default)(_cx, _flexboxgrid2.default['between-' + between], between && _flexboxgrid2.default['between-' + between]), (0, _defineProperty3.default)(_cx, _flexboxgrid2.default['first-' + first], first && _flexboxgrid2.default['first-' + first]), (0, _defineProperty3.default)(_cx, _flexboxgrid2.default['last-' + last], last && _flexboxgrid2.default['last-' + last]), _cx));

      return _react2.default.createElement(
        Tag,
        (0, _extends3.default)({}, rest, { className: _className }),
        children
      );
    }
  }]);
  return Row;
}(_react.Component), _class.propTypes = {
  reverse: _react.PropTypes.bool,
  start: _react.PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  center: _react.PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  end: _react.PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  top: _react.PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  middle: _react.PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  bottom: _react.PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  around: _react.PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  between: _react.PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  first: _react.PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  last: _react.PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  tag: _react.PropTypes.string,
  children: _react.PropTypes.node,
  className: _react.PropTypes.string
}, _class.defaultProps = {
  tag: 'div'
}, _temp);
exports.default = Row;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseGrid/Row/Row.jsx
// module id = 1588
// module chunks = 0